// components/StudentPortal/StudentPortalEntry.js
// Entrada del Portal del Alumno nuevo (flag NEW_STUDENT_HOME, F3).
// - Sin modo elegido -> pantalla S0 (seleccion VR/pantalla).
// - Con modo -> shell tematizado (claro/VR) que albergara el Home "Hoy" (F4).
// Trae su PROPIO shell (no usa AdminLayoutTop) para poder hacer VR a pantalla
// completa y un header propio. Strangler: el portal actual sigue intacto con el
// flag en false (ver AdminRouter).
import React from "react";
import { useStudentModeStore } from "../../store/studentModeStore";
import { ModeSelect } from "./ModeSelect/ModeSelect";
import { StudentShell } from "./StudentShell/StudentShell";

export function StudentPortalEntry() {
  const mode = useStudentModeStore((s) => s.mode);
  if (!mode) return <ModeSelect />;
  return <StudentShell mode={mode} />;
}
